module.exports = __webpack_public_path__ + "static/media/43_Print.e02e5f9f.png";